<template>
  <div class="has-text-centered">
    <p v-if="units" class="heading is-hidden-tablet is-size-6">{{units}} Unit{{units > 1 ? 's' : ''}}</p>
    <p class="title is-4 mb-0">
      {{awayTeam}}
    </p>
    <div class="columns is-vcentered my-0 mh-25px is-mobile">
      <div class="column py-0 pr-1"><hr/></div>

      <div class="column is-narrow py-0 px-0 is-size-5">vs</div>

      <div class="column py-0 pl-1"><hr/></div>
    </div>
    <p class="title is-4">
      {{homeTeam}}
    </p>
  </div>
</template>

<script>
export default {
  props: {
    homeTeam: String,
    awayTeam: String,
    units: Number
  }
}
</script>